<template>
  <div class="container">

      <div class="score-list" v-if="ruleList.length>0" >
          <div class="score-item" @click="navTo()" v-for="(item,index) in ruleList" :key="index">
        <span>{{item.ruleTitle}}</span>
      </div>
      </div>
      <!-- 没有扣分记录提示 -->
    <div v-else class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>
<script>
    import nodata from './components/nodata';// 没有数据
    import api from '../../service/modules/appraise';
    export default {
        components: {
            nodata
        },

        data () {
            return {
                noData: {
                    title: '暂无数据'
                },
                ruleList: [],
                asscessType: ''
            }
        },

        computed: {},

        watch: {},

        methods: {
            getRuleList () {
                api.getAssessRule({
                    upRuleCode: this.asscessType
                }).then(res => {
                    if (res.ret === 0) {
                        this.ruleList = res.data.ruleList
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoringDetail',
                    query: {
                        asscessType: this.asscessType
                    }
                });
            },
            onLoad () {
                // console.log('dddd')
            }
        },

        mounted () {
        },

        created () {
            this.asscessType = this.$route.query.asscessType
            this.getRuleList()
        }

    }
</script>
<style scoped lang="less">
  .container {
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }
    .score-list{
      display: flex;
      flex-direction: column;
      margin: 0 12px;
      .score-item{
        position: relative;
        display: flex;
        align-items: center;
        height: 62px;
        border-bottom: solid 1px #EEEEEE;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        span{
          padding-right: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 62px;
        }
      }
      .score-item::after{
        content: '';
        position: absolute;
        right: 0;
        width: 9px;
        height: 14px;
        background: url(../../assets/appraise/ic_right.png) no-repeat;
        background-size: 9px 14px;
      }
    }
  }
</style>
